import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Application } from '../../../shared/models/application.model';

@Component({
  selector: 'app-other-info-modal',
  templateUrl: './other-info-modal.component.html',
  styleUrls: ['./other-info-modal.component.css'],
})
export class OtherInfoModalComponent implements OnInit {
  @Input() application: Application;
  mailTo: string;

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    this.mailTo = 'mailto:' + this.application?.Mejladress;
  }

  onOpenModal(content) {
    this.modalService.open(content, { centered: true });
  }
}
